import classnames from 'classnames';

export default function CardCTA({ className, label }) {
  return (
    <span
      className={classnames(
        'font-bold text-rose group-hover:text-cornflower text-sm py-2 px-4 border border-rose group-hover:border-cornflower rounded',
        className,
      )}
    >
      {label} &#8594;
    </span>
  );
}
